import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import {Link} from 'react-router-dom';
import './style.css';

class AddSecSubQuestion extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
        this.catID = this.queryString.split("&c:")[1].split("/")[0]; 
        this.quesID = this.queryString.split("&q:")[1].split("/")[0];
        this.subQuesID = this.queryString.split("&sq:")[1].split("/")[0];
    }

    this.state={
        catID : this.catID,
        quesID : this.quesID,
        subQuesID : this.subQuesID,
        order_no :"",
        questions:"",
        selectionType : "",
        validationMsg: {},
    }

    this.onChange = this.onChange.bind(this);
    this.onChangeOption = this.onChangeOption.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  componentWillMount(){

  }

  componentWillReceiveProps(nextProps){
     
    if(nextProps.demoGraphicsSecSubQuestionAddSuccess && nextProps.demoGraphicsSecSubQuestionSuccessmessage){
      alert(nextProps.demoGraphicsSecSubQuestionSuccessmessage);
      window.history.back();
      this.props.emptyDemoSecSubQuestionResponse();
    }else if(nextProps.demoGraphicsSecSubQuestionFailmessage){
      alert(nextProps.demoGraphicsSecSubQuestionFailmessage);
      this.props.emptyDemoSecSubQuestionResponse();
    }
   
  }

  onChange(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeOption(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeRadio(e){
    this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
    
    let valid = true;
    let error = {};

    if (this.state.questions === "") {
        error.questions = "Can't leave empty";
        valid = false;
    }
    if(this.state.selectionType === ""){
        error.selectionType = "Can't leave unselect";
        valid = false;
    }

  
   
    if (this.state.order_no === "") {
      error.order_no = "Please enter order_no";
      valid = false;
		}else if (!this.state.order_no.match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
	}

  saveData(){
    let subQuesData = {};
      if (this.handleValidation()) {
        subQuesData.cat_id = this.state.catID;
        subQuesData.ques_id = this.state.quesID;
        subQuesData.subQuesID = this.state.subQuesID;
        subQuesData.orderSecondSubQues = this.state.order_no;   
        subQuesData.questions = this.state.questions;
        subQuesData.selectionType = this.state.selectionType;  
        this.props.insertSecSubQuestion(subQuesData);  
    }
  }

  gotoBack(){
    window.history.back();
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
                <div className = "studyheader"><h1>Second Sub Question</h1></div>
            <div className = "setbackbutton">
            <br/>

            
            <button className = "editstudybackbtn" onClick={this.gotoBack}  >Back</button>
            
            <br/>
            <div className = "studypage">
            <label id = "lbl1">Question</label>
            <input type="text" className = "textFields" placeholder = "Enter question" name="questions" value={this.state.questions} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.questions}</div><br/>

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Category Order" name="order_no" value={this.state.order_no} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/><br/>
            
            <label id = "lbl1">Option type</label>
            <select  name="selectionType" className="selectOptionType" value={this.state.selectionType} onChange={this.onChangeOption}>
              <option value="">Select Option type</option>
              <option value="select">select</option>
              <option value="checkBox">checkBox</option>
            </select >
            <div style={{ color: "red", textAlign:"center" }} >{this.state.validationMsg.selectionType}</div><br/><br/>

           

            <div>
            
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.saveData}  >Create</button></div><br/>
            </div>
            <p className = "studyMSG">{msg}</p>
       </div>
       </div>
        </div>
        </div>
    );
  }
}
export default AddSecSubQuestion;


// WEBPACK FOOTER //
// ./src/components/demographics/addSecSubQuestion.js